export default "__VITE_ASSET__CIk8bNkY__"